export const ONLY_ALLOWED_ONE = [
    'Right Master Box',
    'Left Master Box',
    'Cab Master Box',
    'DL-18',
    'CTH-518',
    'SC-12 LEFT MASTER',
    'SC-12 RIGHT MASTER',
    'SC-12 CAB MASTER',
    'A SC-12 RETROCORE',
    'A SC-12 CORE HUB',
    'SC-12 LINE PILOT XP',
    'SC-12 CORE HUB',
    'SC-12 RETROCORE',
];

export const MUTUALLY_EXCLUSIVE = [
    'MST-14',
    'Core Hub',
    'Retrocore'
];

// Groups where only one item from the group can be selected
// If any item with a group identifier is selected, all other items with that identifier are filtered out
export const EXCLUSIVE_GROUPS = {
    'SC-12': [
        'SC-12 LEFT MASTER',
        'SC-12 RIGHT MASTER',
        'SC-12 CAB MASTER',
        'A SC-12 RETROCORE',
        'A SC-12 CORE HUB',
        'SC-12 LINE PILOT XP',
        'SC-12 CORE HUB',
        'SC-12 RETROCORE',
    ],
};

// Truck type mappings
export const TRUCK_TYPES = {
    THERMOPLASTIC: 'Thermoplastic',
    EPOXY: 'Epoxy',
    GRINDER: 'Grinder',
    MMA: 'MMA',
    PAINT: 'Paint',
    MRL_GRINDER: 'MRL Grinder',
};

// Hardware items restricted by truck type
export const TRUCK_TYPE_RESTRICTIONS = {
    // 'Proprietary Bag Feeder Option': [TRUCK_TYPES.THERMOPLASTIC],
    // 'Density Based Paint Usage Rates': [TRUCK_TYPES.THERMOPLASTIC],
    // 'Custom MMA System': [TRUCK_TYPES.MMA],
    // 'Epoxy Bi-Directional Pump Control': [TRUCK_TYPES.EPOXY],
    // 'Epoxy Catalyst/Resin Ratio Monitoring': [TRUCK_TYPES.EPOXY],
    // 'Grind Head Depth Control': [TRUCK_TYPES.GRINDER],
    // 'Marker One Grinder Cut Profile': [TRUCK_TYPES.GRINDER],
    // 'Pressure Control': [TRUCK_TYPES.GRINDER],
    // 'Reflective Marker Layout': [TRUCK_TYPES.PAINT],
    // 'Pump Boost': [TRUCK_TYPES.PAINT],
    // 'Wireless Remote': [TRUCK_TYPES.MRL_GRINDER],
};

// Hardware item dependencies - items that require other items to function
export const HARDWARE_DEPENDENCIES = {
    'Temperature Control Feature': 'HDVO-318',
    'CTH-518': 'DL-18',
    'SC-12 LINE PILOT XP': 'DL-18,HDVO-318', //and hdvo
    'CSTAX-VIN8': 'DL-18',
    'ACCU-BEAD Sensor': 'DL-18,CSTAX-VIN8',
    'STINGRAY 2 Laser': 'DL-18',
    'STINGRAY 3 Laser': 'DL-18',
};
